// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__ckVUz","fileBtn":"File_fileBtn__31DjJ","closeBtn":"File_closeBtn__1CyYe","fileSelected":"File_fileSelected__azwM3","disabled":"File_disabled__1gCrz"};